<style lang="scss" scoped>
    @import './scss/ProfitShareView.scss';
</style>

<template>
  <div>
    <crumbs>
        <i class="glyphicon glyphicon-file"></i>
        <span class="text">{{profitShareViewLan.title}}</span>
    </crumbs>
    <div class="principal-wrap">
        <div class="region-box pull-left">
            <div class="btn-group pull-left">
                <button
                class="btn btn-default"
                v-for="(item,key) in profitshare_area"
                :class="{'active': item == curArea}"
                @click="areaGroupSwitchFn(item)"
                >
                    {{item}}
                </button>
            </div>
            <div class="clear"></div>
        </div>
        <btn-group class="primary-box pull-right">
            <btn :class="{'active': (activePrimary == '/accountSetting')}" @click="jump('/profit/accountSetting')">
                {{profitShareViewLan.account_setting}}
            </btn>
            <Dropdown class="pull-left seekDropdown" style="margin-left:-1px">
                <button data-role="trigger" class="btn btn-default dropdown-toggle" :class="{'active': activePrimary.indexOf('Report')!= -1}" type="button">
                    <span>{{profitShareViewLan.profit_report}}</span>
                    <span class="caret"></span>
                </button>
                <template slot="dropdown" v-for="(item,index) in profitShareViewLan.list">
                    <li @click="jump(item.link)" :class="{'active': activePrimary == item.link}">
                        <a href="javascript:;">{{item.text}}</a>
                    </li>
                </template>
            </Dropdown>
        </btn-group>
        <div class="clear"></div>
        <router-view :curArea="curArea"></router-view>
    </div>
  </div>
</template>

<script>
import crumbs from "components/crumbs";
import { BtnGroup,Btn,Dropdown } from 'uiv';
const data = () => {
    return {
        curArea: sessionStorage.currentArea20 ? JSON.parse(sessionStorage.currentArea20).group : '',
    }
}

const mixins = [
    require("common/mixin/base.js").base({profitShareViewLan: "profitShareView"}),
]

const beforeCreate = function () {
    const areaObj = sessionStorage.area20 ? JSON.parse(sessionStorage.area20) : "";
    const profitshare_area = sessionStorage.profitshare_area ? JSON.parse(sessionStorage.profitshare_area) : "";
    const storage = sessionStorage.currentArea20 || "{}";
    let currentArea20 = JSON.parse(storage);
    currentArea20.group = profitshare_area[0];
    currentArea20.value = areaObj[0];
    sessionStorage.currentArea20 = JSON.stringify(currentArea20);
}

const computed = {
    activePrimary: {
        get () {
            return this.$route.path.slice(this.$route.path.lastIndexOf('/'));
        },
        set () {}
    },
    profitshare_area () {
        return JSON.parse(sessionStorage.profitshare_area);
    },
}

const methods = {
    areaGroupSwitchFn(key) {
        this.curArea = key;
        let currentArea20 = JSON.parse(sessionStorage.currentArea20);
        currentArea20.group = key;
        sessionStorage.currentArea20 = JSON.stringify(currentArea20);
    },
    jump (link) {
        sessionStorage.removeItem('back');
        this.$router.push(link);
        this.activePrimary = link;
    },
}

const components = { crumbs, BtnGroup, Btn, Dropdown }

export default {
    name: "profitShareView",
    data,
    beforeCreate,
    mixins,
    computed,
    methods,
    components,
}
</script>



// WEBPACK FOOTER //
// ProfitShareView.vue?b55a3596